import { useState } from 'react';
import './Menu.css';

const Menu = ({ onStart, highScore }) => {
  const [showInstructions, setShowInstructions] = useState(false);

  if (showInstructions) {
    return (
      <div className="menu-overlay">
        <div className="menu-container">
          <h1 className="menu-title">How to Play</h1>
          
          <div className="instructions-section">
            <div className="instruction-group">
              <h3>Controls</h3>
              <div className="control-item">
                <span className="key-combo">
                  <span className="key">W</span>
                  <span className="key">↑</span>
                  <span className="key">Space</span>
                </span>
                <span className="control-desc">Jump</span>
              </div>
              <div className="control-item">
                <span className="key-combo">
                  <span className="key">→</span>
                </span>
                <span className="control-desc">Start Running</span>
              </div>
              <div className="control-item">
                <span className="key-combo">
                  <span className="key">Click</span>
                </span>
                <span className="control-desc">Jump / Start</span>
              </div>
              <div className="control-item">
                <span className="key-combo">
                  <span className="key">ESC</span>
                </span>
                <span className="control-desc">Pause</span>
              </div>
            </div>

            <div className="instruction-group">
              <h3>Objective</h3>
              <p>Navigate through the city skyline by jumping over obstacles.</p>
              <p>The longer you survive, the higher your score!</p>
            </div>

            <div className="instruction-group">
              <h3>Lives</h3>
              <p>You start with <strong>3 lives</strong>.</p>
              <p>Hitting an obstacle costs 1 life and grants 2 seconds of immunity.</p>
              <p>Game over when all lives are lost.</p>
            </div>
          </div>

          <button 
            className="menu-button menu-button-primary" 
            onClick={() => setShowInstructions(false)}
          >
            Back to Menu
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="menu-overlay">
      <div className="menu-container">
        <div className="menu-header">
          <h1 className="menu-title">DashCube</h1>
          <p className="menu-subtitle">Navigate the city skyline!</p>
        </div>

        {highScore > 0 && (
          <div className="high-score-display">
            <span className="trophy">🏆</span>
            <div>
              <p className="high-score-label">High Score</p>
              <p className="high-score-value">{highScore}</p>
            </div>
          </div>
        )}

        <div className="menu-buttons">
          <button 
            className="menu-button menu-button-primary" 
            onClick={onStart}
            autoFocus
          >
            Start Game
          </button>
          <button 
            className="menu-button menu-button-secondary" 
            onClick={() => setShowInstructions(true)}
          >
            How to Play
          </button>
        </div>

        <div className="menu-footer">
          <p>Built with React & Vite</p>
          <a 
            href="https://github.com/barkerbg001/dashcube" 
            target="_blank" 
            rel="noopener noreferrer"
            className="github-link"
          >
            View on GitHub
          </a>
        </div>
      </div>
    </div>
  );
};

export default Menu;

